import {
  JobDetailResponse,
  ScoutJobDetailResponse,
} from '@doda/api-client/aspida/@types';
import { isScoutJobDetailResponse } from '../../utils/castJobType';

/**
 * jobのプロパティを作成 ※毎回定義するのを避けるため。必要なプロパティがあれば、適宜追加する
 * @param {ScoutJobDetailResponse | JobDetailResponse} job - 求人詳細APIの返却値かスカウト求人詳細の返却値
 * @param {boolean} isScout - スカウト求人かどうか
 * @returns {Object} - jobのプロパティ
 */
export const createJobProperty = (
  job: JobDetailResponse | ScoutJobDetailResponse,
  isScout: boolean
) => {
  // 変数定義
  const jid = job?.job?.jid || '';
  const jobOfferKind = job?.job?.jobOfferKind || '1';
  const isApplied = Boolean(job?.apply?.isApplied);
  const isReachedLimit = Boolean(
    isScoutJobDetailResponse(job, isScout) && job.directMessage?.isReachedLimit
  );
  const isBookmarkSaved = Boolean(job.isBookmarkSaved);
  const relationInfoList =
    (isJobDetailResponse(job, isScout) && job.relationInfoList) || [];
  const corporateClientId = job.job?.corporateClientId ?? '';
  const wcnsId = job?.job?.wcnsId || ''; // 原稿種別
  const recruitPrImage = job?.job?.recuruitPrImage;
  const wapid = job.job?.wapid || '';
  const hasDirectLink = Boolean(job.job?.hasDirectLink);
  const directLink = job.job?.directLink || '';
  const isCanSent =
    isScoutJobDetailResponse(job, isScout) &&
    Boolean(job.directMessage?.isCanSent);
  const scoutMessage = isScoutJobDetailResponse(job, isScout)
    ? job.scoutMessage
    : undefined;
  const articleSummaryList = job?.job?.articleSummaryList || [];
  const isRead = 'isRead' in job ? job.isRead || false : false;

  return {
    jid,
    jobOfferKind,
    isApplied,
    isReachedLimit,
    wcnsId,
    recruitPrImage,
    relationInfoList,
    corporateClientId,
    wapid,
    isBookmarkSaved,
    hasDirectLink,
    directLink,
    isCanSent,
    scoutMessage,
    articleSummaryList,
    isRead,
  };
};

/**
 * 型絞り込み
 * @param job
 * @param isScout
 */
const isJobDetailResponse = (
  job: JobDetailResponse | ScoutJobDetailResponse | null,
  isScout: boolean
): job is JobDetailResponse => {
  return job !== null && !isScout;
};
